

    import { defineComponent } from 'vue'
    // import BlockRevealAnimation from '../components/BlockRevealAnimation.vue'
    import Column from '../components/Grid/Column.vue'
    import Grid from '../components/Grid/Grid.vue'
    import Heading from '../components/Heading.vue'
    import LogoWall from '../components/LogoWall.vue'
    import Paragraph from '../components/Paragraph.vue'
    import PageHeader from '../components/PageHeader.vue'
    import ThemeChanger from '../components/ThemeChanger.vue'
    import Slider from '../components/Slider.vue'
    import { useCms } from '../compositions/UseCms'
    import { Route } from '../enums/Route'
    import { Theme } from '../enums/Theme'
    import { useTheme } from '../compositions/UseTheme'
    import { useCarouselSizes } from '../compositions/UseCarouselSizes'
    import MetaInfo from '../components/MetaInfo.vue'
    import Picture from '../components/Picture.vue'
    import BlogImage from '../components/Blog/BlogImage.vue'
    import Anchor from '../components/Anchor.vue'
    // import Button from '../components/Button.vue'

    export default defineComponent({
        name: 'About',
        components: {
            Anchor,
            MetaInfo,
            Heading,
            Grid,
            Column,
            Paragraph,
            Slider,
            LogoWall,
            ThemeChanger,
            // BlockRevealAnimation,
            PageHeader,
            Picture
            // Button
        },
        setup() {

            useTheme().initializeCurrentThemeBasedOnRouteMeta()

            const { about } = useCms()

            const sizes = useCarouselSizes(about.value.asset_2 as any)

            return {
                Route,
                Theme,
                cms: about,
                sliderMedia: about.value.asset_2,
                sizes
            }

        }
    })

